import { setIn } from "timm";
import * as roles from "./roles";
import {
  CanDos,
  PagePermissionsArray,
  PagePermissionsWithActions,
  Role,
} from "../../types/Role";

export default function hasUserPermissions(
  userRoles: Role[] = [],
  pagePermissions: PagePermissionsArray = [],
): boolean {
  let hasPermissions = true;
  const isUserLoggedIn = userRoles.length > 0;
  // go here only if we have specific permission requirements
  if (pagePermissions.length > 0) {
    hasPermissions = false;
    for (
      let i = 0, pagePermission;
      // tslint:disable-next-line
      (pagePermission = pagePermissions[i]);
      i++
    ) {
      // will grant permission if user has any role (she's logged in) and LOGGED_IN is required
      if (pagePermission === roles.LOGGED_IN) {
        hasPermissions = isUserLoggedIn;
        break;
      }
      // will grant permission if user has no roles (she's logged out) if LOGGED_OUT is required
      if (pagePermission === roles.LOGGED_OUT) {
        hasPermissions = !isUserLoggedIn;
        break;
      }
      // will grant permission if user has any of the page permissions
      // @ts-ignore
      if (userRoles.includes(pagePermission)) {
        hasPermissions = true;
        break;
      }
    }
  }
  return hasPermissions;
}

export function canDo(
  userRoles: Role[] = [],
  pagePermissions: PagePermissionsWithActions,
): CanDos {
  return (
    Object.entries(pagePermissions)
      // $FlowFixMe usual Object.entries stuff
      .reduce(
        (canDos, [action, requiredRoles]: [string, PagePermissionsArray]) =>
          setIn(canDos, [action], hasUserPermissions(userRoles, requiredRoles)),
        {},
      )
  );
}
